import * as Yup from 'yup';

export const initialValues = (formik, item) => {
  if(!formik) return;

  let myId = 0;
  if (item != null && (Object.keys(item).length > 0 || item.constructor !== Object)) {
    myId = item.id;
  }

  if(0 < myId){
    formik.setFieldValue('id', myId);
    formik.setFieldValue('code', item.code);
    formik.setFieldValue('status', item.status);
  }
  formik.setFieldValue('email', null);
  formik.setFieldValue('address', null);
};

export const validationSchema = () => {
  // return Yup.object({
  //   email: Yup.string()
  //     .trim()
  //     .notRequired()
  //     .test('email-if-filled', 'Sai định dạng', function (value) {
  //       if (!value || value.trim() === '') return true;     
  //       const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //       const isValid = emailRegex.test(value);
  //       console.log('++++', isValid);
  //       return isValid;
  //     }),
  // });
};

export const handleSubmitted = async (
  values,
  item,
  apiUpdate,
  apiDelete,
  blockAccount, 
  unlockAccount
) => {
  if(values.isRestored){
    unlockAccount(values);
  }else if(values.isVerified){
    if(values.status === 1){
      blockAccount(values);
    }else{
      apiDelete(values);
    }
  }else{
    apiUpdate(values);
  }
};
